<template>
  <div class="action copy-amazon-link" @click="openLink">Post On Amazon</div>
</template>

<script>

import { mapState } from "vuex";

export default {
  name: "PostOnAmazon",
  props: ["assignment"],
  emits: ["clicked"],
  computed: {
    ...mapState({
      user: "user",
      allowedCountries: "allowedCountries"
    }),
    amazonLink() {
      if (!this.assignment.book.web_url) {
        return generateAmazonLink(this.assignment.book)
      }
      let linkDomain = "amazon.com"
      let userDomain = "amazon.com"
        this.allowedCountries.forEach((country) => {
          if (country.country_code === this.user.country_code) {
            userDomain = country.amazon_domain
           }
          if (this.assignment.book.web_url.indexOf(country.amazon_domain) > 0) {
            linkDomain = country.amazon_domain
          }
        })
        
        const asin = this.assignment.book.web_url.match(/(?<=(?:\/dp\/)|(?:\/product\/))[a-zA-Z0-9_]*(?=\/||$)/gm)
        if (!asin || asin.length != 1) {
          return this.assignment.book.web_url.replace(linkDomain, userDomain)
        }

        return "https://" + userDomain + "/review/create-review/?ie=UTF8&channel=glance-detail&asin=" + asin[0]
    }
  },
  methods: {
    openLink() {
      window.open(this.amazonLink, '_blank');
      this.$emit("clicked")
    },
  }
};

function generateAmazonLink(book) {
  let link = "";
  const title = book.amazon_search_title;
  const author = book.amazon_search_author;

  if (!title || !author) {
    return book.web_url;
  }

  // Decide if title or author should come first.
  if (getRandomInt(2)) {
    const by = getRandomInt(2) ? " by" : "";
    link = title + by + " " + author;
  } else {
    link = author + " " + title;
  }

  // Decide if lowercase or title case.
  if (getRandomInt(2)) {
    link = link.toLowerCase();
  } else {
    link = toTitleCase(link);
  }

  // Decide if "book" or "ebook" suffix should be included.
  if (getRandomInt(2)) {
    if (book.manuscript_file_url.indexOf(".epub") !== -1) {
      if (getRandomInt(2)) {
        link += " kindle";
      } else {
        link += "ebook";
      }
    } else {
      link += " book";
    }
  }

  return link;
}

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
}
.copy-amazon-link {
  margin: 0;
  margin-top: -6px;
  font-size: 10.5pt !important;
}
</style>



